<template>
    <iframe class="iframe" :src="url" frameborder="0"></iframe>
</template>

<script setup>
import { ref } from 'vue';

const url = ref()

url.value = new URL('/White Paper for TANG DAO Metaverse - updated 01 Nov 2025.pdf', import.meta.url).href

document.title = 'WhitePaper-TANGDAO METAVERSE'

</script>

<style scoped>
.iframe{
    width: 100vw;
    height: 100vh;
}
</style>